<template>
  <div class="this-page" v-if="load.result">
    <template>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>财务统计</el-breadcrumb-item>
        <el-breadcrumb-item>集运拼团待支付统计</el-breadcrumb-item>
      </el-breadcrumb>

      <div class="timer">
        <div class="block">

          <el-date-picker
              @change="timeChange"
              v-model="timeRange"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions">
          </el-date-picker>
        </div>
      </div>

      <div class="count">
        共{{total}}条符合条件账单  合计待支付 $<span>{{payed}}</span>
      </div>

    </template>
    <template>
      <el-table :data="result" stripe style="width: 100%;" :fit="true" size="small"  :height="tableHeight">
        <el-table-column prop="uid" label="会员号">
        </el-table-column>
        <el-table-column prop="group_id" label="团编号">
        </el-table-column>
        <el-table-column prop="priceTotal" label="账单金额">
        </el-table-column>
        <el-table-column prop="createdAt" label="参团时间">
        </el-table-column>
      </el-table>
      <template>
        <el-pagination style="margin-top:20px" :current-page="page" background layout="prev, pager, next"  :page-count="pageCount" @current-change="pageChange">
        </el-pagination>
      </template>
    </template>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableHeight: document.documentElement.clientHeight - 280 + 'px',
      load: {
        result: false
      },
      result:[],
      page: 1,
      pageCount:1,
      type:"payed",
      timeRange:"",
      paying:"",
      payed:"",
      total:"",
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  mounted() {
    var that = this;
    // <!--把window.onresize事件挂在到mounted函数上-->
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight;

        that.tableHeight = window.fullHeight - 165 + 'px';  // 高

      })()
    };
    this.getStatistics()

  },
  methods: {
    getStatistics() {
      this.$fetch.post('Statistics/groupPayingStatistics', {page:this.page,type:this.type,timeRange:this.timeRange}, true).then(res => {
        this.load.result = true
        this.result = res.result
        this.pageCount = res.page
        this.payed = res.payed
        this.paying = res.paying
        this.total = res.total
      })
    },
    pageChange(e) {
      this.page = e
      this.getStatistics()
    },
    timeChange(){
      this.page = 1
      this.getStatistics()
    }
  }
}
</script>

<style scoped>
.this-page {
  padding: 20px;
  background-color: #FFFFFF;

}
.count{
  padding:10px 0;
}
.count span{
  font-size: 30px;
  padding: 0 10px;
}
.timer{
  padding: 20px 0;
  padding-bottom: 0;
}
</style>
